module.exports = __webpack_public_path__ + "img/img-get-faster-productivity.c9d7606a.png";